import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { FiSettings } from 'react-icons/fi'
import { useLanguageStore } from '../../store/languageStore'
import { resolvePageSettings } from './pageSettingsResolver'
import PageSettingsPanel from './PageSettingsPanel'

interface PageSettingsButtonProps {
  className?: string
}

/**
 * Floating button available on every operational page.
 * Opens a slide-over with related central settings + page-named controls (Page.{PageId}).
 */
export default function PageSettingsButton({ className = '' }: PageSettingsButtonProps) {
  const location = useLocation()
  const { language } = useLanguageStore()
  const isAr = language === 'ar'
  const [open, setOpen] = useState(false)

  const def = useMemo(() => resolvePageSettings(location.pathname), [location.pathname])

  useEffect(() => {
    setOpen(false)
  }, [location.pathname])

  if (!def) return null

  const label = isAr
    ? `إعدادات ${def.label.ar}`
    : language === 'fr'
      ? `Paramètres ${def.label.en}`
      : `${def.label.en} settings`

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`group fixed z-[90] flex h-9 w-9 items-center justify-center rounded-full text-white shadow-lg transition hover:scale-110 active:scale-95 ${className}`}
        style={{
          bottom: '120px',
          [isAr ? 'left' : 'right']: '16px',
          background: 'linear-gradient(135deg, #0f766e 0%, #115e59 100%)',
          boxShadow: '0 8px 22px -6px rgba(15,118,110,0.55)',
        }}
        title={label}
        aria-label={label}
      >
        <FiSettings className="relative h-4 w-4" />
      </button>

      <PageSettingsPanel def={def} open={open} onClose={() => setOpen(false)} />
    </>
  )
}
